export const Errcode = {
  SUCCESS: 0,
  IS_NOT_MEMBER: 20000,
  LOCK_ID_FOR_PIN: 20001,
  MISMATCH_SNS_TYPE: 20002,
  IS_NOT_PIN: 20010,
  MORE_THAN_FIVE_TIMES: 20011,
  IS_NOT_DOWNLOAD_OR_NOT_LOGIN: 20012,
  DUPLICATE_LOGIN: 20013,
  IS_NOT_SUBSCRIBE: 20015,
  FAIL_RECAPTCHA: 20016,
  IS_LOIN_NOT_MEMBER: 20017,
  SAME_PREVIOUS_PIN: 20040,
  DISCONNECTED_TO_OTHER_LOGIN: 9000,
  INTERNAL_ERROR: 9998,
  SESSION_ERROR: 9999,
}
